export type Authority = "GeneralUser" | "Manager" | "Admin" | "MatsuriAdmin"
const authorities: Authority[] = [
    "GeneralUser",
    "Manager",
    "Admin",
    "MatsuriAdmin"
]

export const isGreaterAuthorityThan = (x: Authority, y: Authority) => {
    return authorities.indexOf(x) >= authorities.indexOf(y)
}

type ScopePermission = "none" | "read" | "write" | "admin"
export type AuthScope = Record<string, ScopePermission>

const scopePermissions: ScopePermission[] = ["none", "read", "write", "admin"]

export const isGreaterScopeThan = (x: ScopePermission, y: ScopePermission) => {
    return scopePermissions.indexOf(x) >= scopePermissions.indexOf(y)
}
